"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChartSettings;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdVisualize = require("cccisd-visualize");
var _excluded = ["data"],
  _excluded2 = ["data"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ChartSettings(_ref) {
  var type = _ref.type,
    name = _ref.name,
    data = _ref.data,
    showSummaryStatsToggle = _ref.showSummaryStatsToggle;
  switch (type) {
    case 'bar':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".bar"),
        component: BarSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'line':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".line"),
        component: LineSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'pie':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".pie"),
        component: PieSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'swarm':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".swarm"),
        component: SwarmSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'gauge':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".gauge"),
        component: GaugeSettings,
        data: data,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'bullet':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".bullet"),
        component: BulletSettings,
        data: data,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    default:
      return /*#__PURE__*/_react["default"].createElement(DefaultSettings, {
        showSummaryStatsToggle: showSummaryStatsToggle
      });
  }
}
function BarSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bar.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function LineSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Line.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function PieSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Pie.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function SwarmSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Swarm.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function GaugeSettings(_ref2) {
  var data = _ref2.data,
    props = _objectWithoutProperties(_ref2, _excluded);
  (0, _react.useEffect)(function () {
    var _data$, _props$field$value$ra;
    var maxValue = data ? (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.maxValue : 0;
    if (!((_props$field$value$ra = props.field.value.ranges) !== null && _props$field$value$ra !== void 0 && _props$field$value$ra.length) > 0 && maxValue) {
      props.form.setFieldValue("".concat(props.field.name, ".ranges"), [[maxValue * 0.6, '#d9534f'], [maxValue * 0.8, '#f0ad4e'], [maxValue, '#5cb85c']]);
    }
  }, [data]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Gauge.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function BulletSettings(_ref3) {
  var data = _ref3.data,
    props = _objectWithoutProperties(_ref3, _excluded2);
  (0, _react.useEffect)(function () {
    var _data$2, _props$field$value$ra2;
    var maxValue = data && data[0] && (_data$2 = data[0]) !== null && _data$2 !== void 0 && _data$2.maxValue ? data[0].maxValue : 0;
    if (maxValue !== 0 && !((_props$field$value$ra2 = props.field.value.ranges) !== null && _props$field$value$ra2 !== void 0 && _props$field$value$ra2.length) > 0) {
      props.form.setFieldValue("".concat(props.field.name, ".ranges"), [[maxValue * 0.6, '#d9534f'], [maxValue * 0.8, '#f0ad4e'], [maxValue, '#5cb85c']]);
    }
  }, [data]);
  if (data) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bullet.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
  }
}
function AdditionalSettings(_ref4) {
  var _form$values;
  var field = _ref4.field,
    form = _ref4.form,
    showSummaryStatsToggle = _ref4.showSummaryStatsToggle;
  return /*#__PURE__*/_react["default"].createElement("details", null, /*#__PURE__*/_react["default"].createElement("summary", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Additional Settings")), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Name",
    name: "showLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Question",
    name: "showQuestion",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Total Responses",
    name: "showTotalResponses",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Table",
    name: "showTable",
    component: _cccisdFormik.CccisdToggle
  }), showSummaryStatsToggle && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Summary Statistics",
    name: "showSummaryStats",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Above Chart",
    name: "aboveChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Below Chart",
    name: "belowChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Chart Height",
    name: "chartHeight",
    component: _cccisdFormik.CccisdInput,
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Enable Rollup Threshold",
    name: "enableRollupThreshold",
    component: _cccisdFormik.CccisdToggle
  }), (form === null || form === void 0 ? void 0 : (_form$values = form.values) === null || _form$values === void 0 ? void 0 : _form$values.enableRollupThreshold) && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Rollup Threshold Value",
    name: "rollupThresholdValue",
    component: _cccisdFormik.CccisdInput,
    type: "number",
    min: "0"
  }));
}
function DefaultSettings() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Name",
    name: "showLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Question",
    name: "showQuestion",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Total Responses",
    name: "showTotalResponses",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Above Table",
    name: "aboveChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Below Table",
    name: "belowChart",
    component: _cccisdFormik.CccisdWysiwyg
  }));
}